import { render, staticRenderFns } from "./EditorialProjectsTimeline.vue?vue&type=template&id=61cff4e5&scoped=true&"
import script from "./EditorialProjectsTimeline.vue?vue&type=script&lang=ts&"
export * from "./EditorialProjectsTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./EditorialProjectsTimeline.vue?vue&type=style&index=0&id=61cff4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cff4e5",
  null
  
)

export default component.exports